import {useTranslation} from "react-i18next";
import classNames from "classnames";
import React from "react";

import {INFORMATION} from "utils";

import {Info, SuccessV2} from "assets/svg";
import "./style.scss"

const Information = ({type, text, isTranslation = true}) => {
    const informationBlockStyle = classNames("information-block", type)
    const {t} = useTranslation()

    return (
        <div className={informationBlockStyle}>
            {type === INFORMATION.SUCCESS ? <SuccessV2/> : <Info/>}
            {isTranslation ? <p>{t(text)}</p> : <p>{text}</p>}
        </div>
    )
}

export default Information